// Generated by Melange

import * as ReactRouter from "@tanstack/react-router";
import * as Caml_option from "melange.js/caml_option.jsx";

function requireSubsonicCredentials(param) {
  const $$location = param.location;
  const state = param.context.store.getState();
  const match = state.auth.credentials;
  return Promise.resolve(match !== undefined ? undefined : Caml_option.some(ReactRouter.redirect({
      replace: true,
      search: {
        next: $$location.pathname + $$location.searchStr
      },
      to: "/login"
    })));
}

export {
  requireSubsonicCredentials,
}
/* @tanstack/react-router Not a pure module */
